function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.61 13.731l-3.095-3.096a6.84 6.84 0 00-1.348-9.084 6.83 6.83 0 00-9.166.452 6.839 6.839 0 00-.449 9.172 6.831 6.831 0 009.079 1.346l3.095 3.095c.524.512 1.36.512 1.884 0 .52-.52.52-1.364 0-1.885zM6.84 2.008a4.832 4.832 0 014.83 4.833 4.831 4.831 0 11-9.661 0 4.837 4.837 0 014.83-4.833z"
});

function SvgHappySearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgHappySearch;